import { eq, sql } from "drizzle-orm";
import { carts, cartItems } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";

type Db = TestDb;

export function computeCartTotals(
  lines: { priceKopecks: number; qty: number }[],
): { subtotalKopecks: number; itemCount: number } {
  let subtotalKopecks = 0;
  let itemCount = 0;
  for (const l of lines) {
    subtotalKopecks += l.priceKopecks * l.qty;
    itemCount += l.qty;
  }
  return { subtotalKopecks, itemCount };
}

export async function mergeGuestCartIntoServer(
  db: Db, counterpartyId: string, guestItems: { productId: string; qty: number }[],
): Promise<void> {
  let [cart] = await db.select().from(carts).where(eq(carts.counterpartyId, counterpartyId));
  if (!cart) [cart] = await db.insert(carts).values({ counterpartyId }).returning();
  for (const item of guestItems) {
    await db.insert(cartItems)
      .values({ cartId: cart.id, productId: item.productId, qty: item.qty })
      .onConflictDoUpdate({
        target: [cartItems.cartId, cartItems.productId],
        set: { qty: sql`${cartItems.qty} + ${item.qty}` },
      });
  }
}
